// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__IjY1b","title":"Info_title__beTvW","selects":"Info_selects__2TXOm","requiredAsterisk":"Info_requiredAsterisk__2-EV_"};